import { Controller } from "@hotwired/stimulus"

// Une case à cocher qui montre ou cache une zone : cochée, la zone
// `content` apparaît ; décochée, elle disparaît (ses champs restent dans le
// formulaire, le serveur les ignore si la case n'est pas cochée).
export default class extends Controller {
  static targets = ["checkbox", "content"]

  connect() {
    this.sync()
  }

  sync() {
    this.contentTarget.hidden = !this.checkboxTarget.checked
  }
}
